import { Container } from "react-bootstrap";

export default function Layout(props) {
  return <Container className="mt-3">{props.children}</Container>;
}
